import React, { Fragment, useEffect, useState } from "react";
import { myAccList } from "../../Common/headerName";
import ManageInfo from "./ManageInfo";
import LicenseManage from "../../License/LicenseManage";
import { Box, Button } from "@material-ui/core";
import ChangePass from "./ChangePass";
import { getApiUserRoles } from "../../../Utils/actions";
import { useDispatch } from "react-redux";
import "./ManageInfo.css";
import { Card, Tooltip } from "react-bootstrap";
import ManageLicenseKey from "./ManageLicenseKey";

const ManageDetails = () => {
  const [render, setRender] = useState("userDetail");
  const dispatch = useDispatch();
  const appRender = (value) => {
    setRender(value.value[0]);
  };

  useEffect(() => {
    document.body.classList.add("managedetails1");
    dispatch(getApiUserRoles(sessionStorage.getItem("username")));
  }, []);

  const cmpntGroup =
    sessionStorage.getItem("cmpntGroup") !== null
      ? JSON.parse(sessionStorage.getItem("cmpntGroup"))
      : "{}";

  // value == "manage"
  const isButtonDisabled = (value) => {
    // return value == "manage";
  };
  return (
    <Fragment>
      <Card
        className={"w-100 manage-user-card"}
        style={{
          overflow: "auto",
          height: "89vh",
          border: "none",
          borderRadius: "unset",
        }}
      >
        <Card.Body
          className={"manage-user"}
          style={{ overflow: "hidden", padding: "0px" }}
        >
          {/* <div className={"dashboard_div_content"} style={{ backgroundColor: "#dcebfed9", padding: "15px",overflow: "auto", height: "86vh"}}> */}
          <div
            className={"d-flex col-md-12 manage_user_sub_content userDetails"}
            style={{
              backgroundColor: "#1e1e1e",
              // borderRadius: "5px",
              padding: "0px",
            }}
          >
            <div className={"col-md-2 user-menu"}>
              <Box
                component={"legend"}
                className="col-md-12 user-menu-content"
                style={{ top: "12px", paddingLeft: "0px", paddingRight: "0px" }}
              >
                {myAccList.map((n, index) => (
                  <div key={index}>
                    {n.value === "manage" ? (
                      cmpntGroup["license"]?.Read ? (
                        <Button
                          className="col-md-12"
                          style={{
                         backgroundColor: isButtonDisabled(n.value)
                          ? "rgb(53 101 133 / 72%)"
                          : render === n.value
                          ? "#242424" //"#154b6e"
                          : "#333333",
                            height: "55px",
                            color: "#c7c7c7",
                            width: "100%",
                            margin: "5px 0px 5px 0px",
                            textTransform: "none",
                            borderBottom:
                          render === n.value ? "3px solid white" : "none",
                            cursor: isButtonDisabled(n.value)
                              ? "not-allowed"
                              : "pointer",
                          }}
                          onClick={() => appRender({ value: [n.value] })}
                          disabled={isButtonDisabled(n.value)}
                        >
                          <b style={{ fontSize: "14px" }}>{n.name}</b>
                        </Button>
                      ) : null
                    ) : (
                      <Button
                        className="col-md-12"
                        style={{
                          backgroundColor: isButtonDisabled(n.value)
                          ? "rgb(53 101 133 / 72%)"
                          : render === n.value
                          ? "#242424" //"#154b6e"
                          : "#333333",
                            height: "55px",
                            color: "#c7c7c7",
                            borderBottom:
                          render === n.value ? "3px solid white" : "none",
                          width: "100%",
                          margin: "5px 0px 5px 0px",
                          textTransform: "none",
                          cursor: isButtonDisabled(n.value)
                            ? "not-allowed"
                            : "pointer",
                        }}
                        onClick={() => appRender({ value: [n.value] })}
                        disabled={isButtonDisabled(n.value)}
                      >
                        <b style={{ fontSize: "14px" }}>{n.name}</b>
                      </Button>
                    )}
                  </div>
                ))}
              </Box>
            </div>
            <div className="col-md-10  p-0 h-100" style={{}}>
              {render === "userDetail" && (
                // <div
                //   className="d-flex"
                //   style={{
                //     backgroundColor: "#dcebfed9",
                //     height: "86vh",
                //     justifyContent: "center",
                //     alignItems: "center",
                //   }}
                // >
                <ManageInfo />
              )}
              {/* {cmpntGroup["license"]?.Read && render === "manage" && ( */}
                {/* // <div
                //   className="d-flex"
                //   style={{ position: "relative", height: "97%" }}
                // >
                // <LicenseManage /> */}
                {render === "manage" && (

                <ManageLicenseKey />
                )}
                {/* // </div> */}
              {/* )} */}
              {render === "changePass" && (
                // <div
                //   className="d-flex"
                //   style={{
                //     backgroundColor: "#dcebfed9",
                //     height: "86vh",
                //     justifyContent: "center",
                //     alignItems: "center",
                //   }}
                // >
                <ChangePass />
                // </div>
              )}
            </div>
          </div>
        </Card.Body>
      </Card>
    </Fragment>
  );
  // return (
  //   <div className="col-md-12 licencepage">
  //     <div className="col-md-12 d-flex p-0 m-0 licenceDetails">
  //       <div className="col-md-2 licence-menu" style={{ paddingLeft: '0px'}}>
  //         <Box
  //           component={"legend"}
  //           className="col-md-12"
  //           style={{ top: "12px", paddingLeft: "0px", paddingRight: "0px"}}
  //         >
  //           <div
  //             className="headerName"
  //             style={{ margin: "0px 0px 0.5rem 0.9rem" }}
  //           >
  //             {/* <h4>App Setting</h4> */}
  //           </div>
  //           {myAccList.map((n) => (
  //             <div>
  //               <Button
  //                 className="col-md-12"
  //                 style={{
  //                   // backgroundColor: "#286685",
  //                   backgroundColor: isButtonDisabled(n.value) ? "rgb(53 101 133 / 72%)" : "#286685",
  //                   width: "100%",
  //                   color: "#fff",
  //                   margin: "5px 0px 5px 0px",
  //                   textTransform: "none",
  //                   cursor: isButtonDisabled(n.value) ? "not-allowed" : "pointer",
  //                 }}
  //                 onClick={() => appRender({ value: [n.value] })}
  //                 disabled={isButtonDisabled(n.value)}
  //               >
  //                 <b style={{ fontSize: "14px" }}>{n.name}</b>
  //               </Button>
  //             </div>
  //           ))}
  //         </Box>
  //       </div>
  //       <div className="col-md-10 p-0 m-0 licenceContent" style={{ height: "660px" }}>
  //         {render === "userDetail" && (
  //           <div
  //             className="d-flex"
  //             style={{
  //               backgroundColor: "#dcebfed9",
  //               height: "86vh",
  //               justifyContent: "center",
  //               alignItems: "center",
  //             }}
  //           >
  //             <ManageInfo />
  //           </div>
  //         )}
  //         {render === "manage" && (
  //           <div
  //             className="d-flex"
  //             style={{ position: "relative", height: "97%" }}
  //           >
  //             <LicenseManage />
  //           </div>
  //         )}
  //         {render === "changePass" && (
  //           <div
  //             className="d-flex"
  //             style={{
  //               backgroundColor: "#dcebfed9",
  //               height: "86vh",
  //               justifyContent: "center",
  //               alignItems: "center",
  //             }}
  //           >
  //             <ChangePass />
  //           </div>
  //         )}
  //         {/* {render === 'emailTab' && <EmailNotify />}
  //                   {render === 'rawDataTab' && <RawDataPersist />}
  //                   {render === 'dqTab' && <DataQuality />}
  //                   {render === 'dProvidersTab' && <DataQuality />}
  //                   {render === 'dProviderTab' && <DataQuality />} */}
  //       </div>
  //     </div>
  //   </div>
  // );
};

export default ManageDetails;
